import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainApp from './MainApp';
import Hub from './components/Hub';
import OIDCProvider from './contexts/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute';

const App: React.FC = () => {
  return (
    <OIDCProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Hub />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <MainApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <MainApp />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </OIDCProvider>
  );
};

export default App; 